export enum EventType {
  NEW_CAMPAIGN_POST = 'new_campaign_post'
}

export enum EventFilterType {
  CAMPAIGN_ID = 'campaign_id',
  INFLUENCER_ID = 'influencer_id',
  URL_HASH = 'url_hash'
}

export class EventFilter {
  type: EventFilterType;
  value: number;
  constructor (type: EventFilterType, value?: number) {
    this.type = type;
    this.value = value;
  }
}

export class NewEvent {
  type: string;
  since: number;
  aggregator: string;
  count: number;
  events: EventPairValue[] = [];
}

export class EventPairValue {
  key: string;
  value: number;
}



// WEBPACK FOOTER //
// ./src/models/user-notification.ts